module.exports = __webpack_public_path__ + "static/media/vlad.6f88d4c6.jpg";